module.exports = __webpack_public_path__ + "img/bdoubleo100-e08be95c-b6a1-4b93-ddf8-08d959eef549.png";